import { render, staticRenderFns } from "./ModalSetTrainingTopic.vue?vue&type=template&id=36ffdd82&scoped=true&"
import script from "./ModalSetTrainingTopic.vue?vue&type=script&lang=js&"
export * from "./ModalSetTrainingTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ffdd82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
